import React, { useEffect } from 'react'
import { useVM } from '../../Structure/utilities/ViewModelStructure'
import { AccountsVM } from '../../Structure/ViewModels/Admin/AccountsVM'
import { Col, Container, Row } from 'react-bootstrap'
import CustomSelect from '../Utilities/CustomSelect'

const Accounts = () => {
  const control = useVM<AccountsVM>(new AccountsVM())
  useEffect(()=>{control.getData()},[control.Changed])

  return (
    <Container className='h-100'>
    {
      control.Show(
      <Row className=' justify-content-center text-center'>
        <h3 className='py-2'>
          حسابات التحويل
          <div className='d-flex justify-content-center'>
            <div className='d-flex p-2 fs-6 c-pointer'>
                <input type="checkbox"
                    id="active" checked={control.status=='active'}
                    onChange={a=>control.status=a.target.checked?'active':'inActive'} 
                />
                <label htmlFor="active" className='px-2 c-pointer'>النشطين</label>
            </div>
          </div>
        </h3>
        {
          control.Data?.filter(a=>a.status==control.status).map((item,index)=>(
            <Col key={index} xl={4} className='p-3 py-5 justify-content-center d-flex'>
              <div style={{ maxWidth:'200px' }}>
                <div className='py-1'>
                  <input type="text" className='input-field w-100' value={item.name}  onChange={a=>{control.changeName(item.id,a.target.value)}} />
                </div>
                <div className='py-1'>
                  <CustomSelect clearable={false} list={control.Currencies.filter(a=>a.status=='active').map(a=>({label:a.arabic_currency_name , value:a.id}))} selected={item.bank_account_id} onSelect={a=>{control.changeCurrencyId(item.id,a)}} />
                </div>
                <div className='py-1 d-flex justify-content-center'>
              <div className='d-flex p-1'>
                <button className='button-II btn-cl-I px-3' onClick={()=>{control.edit(item)}}>حفظ</button>
              </div>
              <div className='d-flex p-1'>
                {
                  control.status=='active'?(
                    <button className='button-II btn-cl-I bg-danger px-3' onClick={()=>{control.changeState(item.id, 'inActive')}}>تعطيل</button>
                  ):(
                    <button className='button-II btn-cl-I bg-success px-3' onClick={()=>{control.changeState(item.id, 'active')}}>تفعيل</button>
                  )
                }
              </div>
            </div>
              </div>
            </Col>
          ))
        }
        {
          control.status=='active'?(
        <Col xl={4} className='p-3 justify-content-center d-flex'>
          <div style={{ maxWidth:'200px' }}>
            <div className='py-1'>
              <input type="text" className='input-field w-100' value={control.NewAccount.name}  onChange={(a)=>control.Name=a.target.value} placeholder='اسم الحساب...'/>
            </div>
            <div className='py-1'>
              <CustomSelect list={control.Currencies.filter(a=>a.status=='active').map(a=>({label:a.arabic_currency_name , value:a.id}))} selected={control.NewAccount.id} onSelect={a=>control.BankAccountId=a} />
            </div>
            <div className='py-1'>
              <button className='button-II btn-cl-I' onClick={()=>{control.sendNew()}}>اضافة</button>
            </div>
          </div>
        </Col>):null
        }
      </Row>)
      }
    </Container>
  )
}

export default Accounts
